@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.item-quantity-count {
  color: @scan-page--item-list-verified-row-order-count--text-color;
}

.row-cell {
  background-color: @scan-page--item-list-verified-row-cell--background-color;
}
